import React from "react";

export default function ABCID() {
  return (
    <>
      <section
        className="section"
        style={{
          position: "relative",
          top: "185px",
          marginBottom: "100px",
          padding: "50px",
        }}
      >
        <p
          className=""
          style={{
            textAlign: "justify",
            fontSize: "1.2em",
            padding: "20px",
            marginBottom: "120px",
          }}
        >
          Digi Locker and NAD are initiatives of the Ministry of Electronics and
          Information Technology (MeitY) and Ministry of Education (MoE)
          respectively. The concept of National Academic Depository (NAD) is
          born out of an initiative by MoE to provide a 24/7 online depository
          to Academic institutions to store and publish their academic awards.
          The digital depository not only ensures easy access to and retrieval
          of an academic award but also validates and guarantees its
          authenticity and safe storage. NAD facilitates digital issuance,
          storage, access, and verification of academic records issued by
          academic institutions anytime, anywhere. Digi Locker is a provider of
          NAD services and aims at the ‘Digital Empowerment’ of citizens by
          providing access to authentic digital documents to citizen’s digital
          document wallets. The issued documents in the Digi Locker system are
          deemed to be at par with original physical documents as per Rule 9A of
          the Information Technology (Preservation and Retention of Information
          by Intermediaries Providing Digital Locker facilities) Rules, 2016.
          For more details on NAD please visit https://www.nad.gov.in To
          Register in NAD, Click Here As per National Education Policy 2020, the
          Academic Bank of Credits (ABC) has been envisaged to facilitate the
          academic mobility of students with the freedom to study across the
          Higher Education Institutions in the country with an appropriate
          "credit transfer" mechanism from one programme to another, leading to
          attain a Degree/ Diploma/PG-diploma, etc., For more details on the
          Academic Bank of Credits (ABC) please visit https://www.abc.gov.in
          APAAR, which stands for Automated Permanent Academic Account Registry,
          is a specialized identification system designed for all students in
          India. This initiative is part of the `One Nation, One Student ID`
          program launched by the government, aligning with the new National
          Education Policy of 2020 For more details on APAAR please visit
          https://apaar.education.gov.in/ JSS University, Noida has registered
          for NAD, ABC and APAAR.
          <br />
        </p>
      </section>
    </>
  );
}
